import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { EstimateProfitUtil } from '@/class/cargo/model/utils/EstimateProfitUtil'
import { CreditControlUtil } from '@/class/cargo/model/utils/CreditControlUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import ErrorTip from '@/utils/class/ErrorTip'
import { deepCopy } from '@/utils/commonUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { cacheKeys, resolveSpecificField2ItemByCustomType } from '@/utils/basicDataCache'

export class BookingWorkspacePM {
  /**
  * @param {Object} view 视图
  */
  constructor(view) {
    this.view = view
    this.$message = view.$message
    this.$confirm = view.$confirm
    this.chargeAccountIdObject = null
    this.checkEstimate = false
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get currentRow() {
    return this.view.currentRow
  }
  set currentRow(currentRow) {
    this.view.currentRow = currentRow
  }
  get paramsOfTab() {
    return this.view.paramsOfTab
  }
  set paramsOfTab(paramsOfTab) {
    this.view.paramsOfTab = paramsOfTab
  }
  /**
   * 在保存前进行校验
   */
  async checkBeforeSave(bodyJob) {
    const job = this.paramsOfTab
    const jobForCheck = bodyJob || job
    // 业务规则：自定义业务类型=J类或K类时，尾程商务负责人必填
    if (jobForCheck && jobForCheck.lob === 'SE' && this.isCustomJobTypeJK(jobForCheck) && !jobForCheck.lastMilePlanner) {
      // 引导用户回到“基本”页签填写（不同业务形态基础页签 name 不同）
      if (this.view && ('activeTabName' in this.view)) {
        if (jobForCheck.masterFlag) {
          this.view.activeTabName = this.view.isBuyerConsoleFcl ? 'tabBuyerConsoleFclBookingMaster' : 'tabBookingMaster'
        } else {
          this.view.activeTabName = 'tabBookingFCL'
        }
      }
      this.$message.warning(this.view.$t('Message.FieldValueCannotBeNull', [this.view.$t('CargoMsg.Cargo_LastMileBusinessLeader')]))
      return false
    }
    // 业务规则：贸易条款不为FOB时，航线负责人必填
    if (jobForCheck && jobForCheck.lob === 'SE' && jobForCheck.incoTerm && String(jobForCheck.incoTerm).toUpperCase() !== 'FOB' && !jobForCheck.planner) {
      // 引导用户回到“基本”页签填写（不同业务形态基础页签 name 不同）
      if (this.view && ('activeTabName' in this.view)) {
        if (jobForCheck.masterFlag) {
          this.view.activeTabName = this.view.isBuyerConsoleFcl ? 'tabBuyerConsoleFclBookingMaster' : 'tabBookingMaster'
        } else {
          this.view.activeTabName = 'tabBookingFCL'
        }
      }
      this.$message.warning('贸易条款不为FOB时，航线负责人必填')
      return false
    }
    // 中邮委托单位是否黑名单
    const blacklist = await JobUtils.checkBlacklistByCustomerId(job.customerId, !(job.uuid && job.customerId === this.currentRow.customerId))
    if (blacklist) {
      if (!job.uuid || (job.uuid && job.customerId !== this.currentRow.customerId)) {
        return false
      }
    }
    const reqInputCharge = Number(this.config.get('saveCharge')) === 1
    const isBookingFeeMandatoryAppliedGlobally = Number(this.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
    if (!(job.lclMasterUuid && !job.uuid) && !SecurityUtil.checkSaveCharge(reqInputCharge, job, isBookingFeeMandatoryAppliedGlobally)) {
      return
    }
    // 判断主票新增小票后，编辑小票，判断费用是否都是新创建的，如果是，对小票进行预估计算以及利润率验证
    let isNewCharge = false
    let index = 0
    if (job.lclMasterUuid && job.charges && job.charges.length > 0 && job.uuid) {
      for (const c of job.charges) {
        if (c.uuid && (c.uuid.startsWith('addTabCost__') || c.uuid.startsWith('addTabSelling__'))) c.uuid = ''
        if (!c.uuid) {
          index++
        }
      }
      if (job.charges.length === index) {
        isNewCharge = true
      }
    }
    // 不更新賬單信息
    job.skipBillsForNextTransaction = true
    // 有些数据无需保存
    if (job.charges) {
      for (const c2 of job.charges) {
        c2.skipClearHistoryForNextTransaction = true
        c2.skipHedgeChargeForNextTransaction = true
      }
    }
    if (((!job.lclMasterUuid && !job.uuid) || isNewCharge) && reqInputCharge && !this.checkEstimate && !isBookingFeeMandatoryAppliedGlobally) {
      this.checkEstimate = await EstimateProfitUtil.checkEstimate(job, params => {
        let resolveRef = null
        const result = new Promise(resolve => {
          resolveRef = resolve
        })
        const dialog = this.view.estimateValidationDialog
        dialog.job = params.job
        dialog.estimateProfitRate = params.estimateProfitRate
        dialog.tatolProfit = params.tatolProfit
        dialog.callback = isSave => {
          resolveRef(isSave)
        }
        dialog.visible = true
        return result
      })
      bodyJob.estimateAccountsReceivable = job.estimateAccountsReceivable
      bodyJob.estimateAccountsPayable = job.estimateAccountsPayable
      bodyJob.estimateAccountsPayable = job.estimateAccountsPayable
      bodyJob.situation = job.situation
      if (!this.checkEstimate) {
        return
      } else {
        this.checkEstimate = false
      }
    }
    let flag = await CreditControlUtil.checkCreditBlack(job, !blacklist, this.currentRow)
    if (!flag) {
      return false
    }
    flag = await this.checkSalesChenged()
    if (!flag) {
      return false
    }
    flag = await this.checkOpSales()
    if (!flag) {
      return false
    }
    flag = await this.checkWarehouseRecord()
    if (!flag) {
      return false
    }
    flag = await this.checkChargeAccountId()
    if (!flag) {
      return false
    }
    flag = await this.checkCargoSource()
    if (!flag) {
      return false
    }
    flag = await this.checkSoNoDuplicated()
    if (!flag) {
      return false
    }
    const needConfirmeDuplicateWarehouseNo = Number(this.config.get('needConfirmeDuplicateWarehouseNo')) === 1
    if (needConfirmeDuplicateWarehouseNo && job.warehouseNo) {
      const fieldExistResult = await SeaExportJob.checkJobFieldExist(this.context.office.officeId, job.lob, { warehouseNo: job.warehouseNo }, job.uuid)
      if (typeof fieldExistResult.warehouseNo !== 'undefined') {
        flag = await this.checkWarehouseNo(fieldExistResult.warehouseNo)
        if (!flag) {
          return false
        }
      }
    }
    // if (!job.lclMasterUuid) {
    //   // 验证MBL是否重复，若是重复则不允许保存
    //   const mblNoDuplicateCanNotBeSaved = Number(this.config.get('MblNoDuplicateCanNotBeSaved')) === 1
    //   if (mblNoDuplicateCanNotBeSaved && bodyJob && bodyJob.mbl && bodyJob.mbl.trim()) {
    //     flag = await this.checkMBLNoRepeat(bodyJob)
    //     if (!flag) {
    //       return false
    //     }
    //   } else {
    //     flag = await this.isExistMBLSeaExport()
    //     if (!flag) {
    //       return false
    //     }
    //   }
    // }
    flag = await this.checkHBLExistHandler()
    if (!flag) {
      return false
    }

    const needConfirmCustomerRefNo = Number(this.config.get('needConfirmCustomerRefNo')) === 1
    if (needConfirmCustomerRefNo && job.customerRefNo && job.customerRefNo.trim()) {
      flag = await this.checkCustomerRefNo()
      if (!flag) {
        return false
      }
    }
    if (job.soNo) {
      flag = await this.checkSoNo(job, job.soNo.replace(/\n/g, ','))
      if (!flag) {
        return false
      }
    }
    flag = await this.checkAmsContainersHandler()
    // if (!flag) {
    //   return false
    // }
    // 校验是否关账
    const validateClosingAccount = Number(this.config.get('ValidateClosingAccount')) === 1
    if (validateClosingAccount) {
      flag = await JobUtils.checkJobOfClosingAccount(job.opOffice, job.etd)
      if (!flag) {
        return false
      }
    }
    // 新增情况下，验证是否填写自定义业务类型
    if (!job.uuid) {
      flag = await JobUtils.checkCustomJobType(job)
      if (!flag) {
        return false
      }
    }
    flag = await JobUtils.checkHBLANDMBL(job)
    if (!flag) {
      return false
    }
    flag = JobUtils.checkReduceContainerNum(this.currentRow, job)
    if (!flag) {
      return false
    }
    const needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
    // needConfirmProjectNo【是否要验证项目编号重复】; openProjectConfig【是否开启项目管理】
    if (job.poNo && needConfirmProjectNo && Number(this.config.get('openProjectConfig')) === 0) {
      flag = await JobUtils.isPoNoExist(job.poNo, job.uuid)
      if (!flag) {
        return false
      }
    }
    const editMblNoMode = String(this.config.get('EditMblNoMode')) === '2' || String(this.config.get('EditMblNoMode')) === '3' // 2 太平 3 巴士
    if (editMblNoMode) {
      let flag = true
      const res = await JobUtils.checkMblAvailable(job)
      if (res && res.data) {
        if (res.data === '1') {
          await this.$confirm(this.view.$t('CargoMsg.Cargo_receiveTip'), {
            confirmButtonText: this.view.$t('Message.Yes'),
            cancelButtonText: this.view.$t('Message.No'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            flag = true
          }).catch(() => {
            flag = false
          })
        } else if (res.data === '2') {
          await this.$confirm(this.view.$t('CargoMsg.Cargo_receiveTip2'), {
            confirmButtonText: this.view.$t('Message.Yes'),
            cancelButtonText: this.view.$t('Message.No'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            flag = true
          }).catch(() => {
            flag = false
          })
          // this.view.$message.warning(this.view.$t('CargoMsg.Cargo_receiveTip2'))
          // flag = false
        } else {
          // 当前mblNo配置的唯一值
          bodyJob.mblManager = res.data
          flag = true
        }
      }
      if (!flag) {
        return false
      }
    }
    JobUtils.checkEqSizeEqType(job)
    // CARGO-36183 数据服务-增加船公司必填条件，及软提示
    // // 计费系统相关验证
    // flag = !await JobUtils.checkShippingCompanyCargoTracking(job)
    // if (!flag) {
    //   // 模拟切换页签
    //   const activeTabName = job.masterFlag ? 'tabBookingMaster' : 'tabBookingFCL'
    //   const isSameActiveTabName = activeTabName !== this.view.activeTabName
    //   if (isSameActiveTabName) {
    //     this.view.beforeLeaveTab(activeTabName, this.view.activeTabName)
    //     this.view.activeTabName = activeTabName
    //     this.view.handleTabClick()
    //   }
    //   return false
    // }
    return flag
  }
  /**
   * 检查销售是否发生变更
   */
  async checkSalesChenged() {
    const job = this.paramsOfTab
    // 手动修改销售时，salesRecord为销售新值，联动修改销售时，此处将salesRecord改为旧值
    if (typeof job.salesRecord === 'undefined') {
      job.salesRecord = this.currentRow.sales
    }
    const norminationJobSaleType = Number(this.config.get('NorminationJobSaleType')) === 1
    if (job.uuid && job.salesRecord !== job.sales && (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code || norminationJobSaleType) && this.currentRow.sales !== job.sales) {
      return await this.$confirm(this.view.$t('Message.ChangeSelectSales'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }

  // 自定义业务类型为 J类 / K类 时，需要填写尾程商务负责人
  isCustomJobTypeJK(job) {
    const code = job && job.customJobType
    if (!code) return false
    // 大部分环境自定义业务类型的 code 就是单字母（J/K）
    if (code === 'J' || code === 'K') return true
    // 兼容 code 不是 J/K，但名称为 J类/K类 的情况（需按 lob 区分）
    const item = resolveSpecificField2ItemByCustomType(cacheKeys.basic_data_CutomJobType, 'code', code, job.lob)
    const name = (item && (item.localName || item.name || item.englishName)) || ''
    return name.startsWith('J类') || name.startsWith('K类')
  }
  /**
   * 检查销售和操作是否相同
   */
  async checkOpSales() {
    const job = this.paramsOfTab
    if (String(this.config.get('ToExoSystem')) !== 'SZBM' && job.sales !== 0 && job.sales === job.op) {
      return await this.$confirm(this.view.$t('Message.TheSameSalesAndOperationsConfirmThatYouWantToSave'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 检查仓库是否清除
   */
  async checkWarehouseRecord() {
    const job = this.paramsOfTab
    if (typeof job.warehouseRecord === 'undefined') {
      job.warehouseRecord = this.currentRow.warehouseCmp || 0
    }
    if (!job.warehouseCmp) job.warehouseCmp = 0
    if (job.uuid && job.warehouseRecord !== job.warehouseCmp && !job.masterFlag) {
      return await this.$confirm(this.view.$t('Message.UpdateWarehouseRecord'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  /**
   * 验证费 输入
   */
  async checkChargeAccountId() {
    // 修改2涉及文件
    const job = this.paramsOfTab
    let messageTitle = ''
    let company = null
    if (job.charges && job.charges.length > 0) {
      for (const charge of job.charges) {
        if (charge.accountId > 0) {
          company = this.companyList.find(p => p.cmpIdx === charge.accountId)
          if (company && !company.active) {
            if (!this.chargeAccountIdObject || !this.chargeAccountIdObject[company.uuid]) {
              if (company.chineseName) {
                messageTitle = this.view.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.chineseName)
              } else {
                messageTitle = this.view.$t('SeaExport.CostSettlementObjectBlocked').replace('{0}', company.englishName)
              }
              break
            }
          }
        }
      }
    }
    if (messageTitle) {
      return await this.$confirm(messageTitle, this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.chargeAccountIdObject = this.chargeAccountIdObject || {}
        this.chargeAccountIdObject[company.uuid] = company.uuid
        return true
      }).catch(() => false)
    } else {
      return true
    }
  }
  /**
  * 检查揽货类型和小票
  */
  async checkCargoSource() {
    const job = this.paramsOfTab
    if (job.masterFlag) {
      let notSame = false
      if (job.lclSlaves) {
        for (const item of job.lclSlaves) {
          if (item.cargoSource !== job.cargoSource) {
            notSame = true
            break
          }
        }
      }
      if (notSame) {
        return await this.$confirm(this.view.$t('Message.SolicitationTypeIsNotTheSameAsSubBillDoYouWantToSaveIt'), this.view.$t('Message.Prompt'), {
          confirmButtonText: this.view.$t('constant.yes'),
          cancelButtonText: this.view.$t('constant.no'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => true).catch(() => false)
      }
    }
    return true
  }
  /**
   * 检测WarehouseNo是否重复
   */
  async checkWarehouseNo(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.WHNoRepeatedContinue'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
  /**
   * 检查MBL是否可用
   */
  async checkMBL() {
    const job = this.paramsOfTab
    if (job.mbl && job.mbl.trim()) {
      const count = await SeaExportJob.isExistMBL(job.opOffice, 'SE', job.mbl, job.uuid, job.etd)
      const editMblNoMode = String(this.config.get('EditMblNoMode')) === '3' // 3 巴士
      if (editMblNoMode) {
        const resultFlag = await SeaExportJob.isExistMBLNotCurrentCompany(job.opOffice, job.mbl, job.opDepartment)
        if (count > 0 && resultFlag) {
          return await this.checkMBLHandler(true)
        }
        if (resultFlag) {
          return await this.checkMBLNotCurrentCompanyHandler(true)
        }
      }
      return await this.checkMBLResultHandler(count > 0)
    } else {
      return true
    }
  }

  /**
   * 检查该租户下的MBL是否可用  CARGO-50098
   */
  async isExistMBLSeaExport() {
    const job = this.paramsOfTab
    if (job.mbl && job.mbl.trim()) {
      const count = await SeaExportJob.isExistMBLSeaExport(job.opOffice, 'SE', job.mbl, job.uuid, job.etd)
      const editMblNoMode = String(this.config.get('EditMblNoMode')) === '3' // 3 巴士
      if (editMblNoMode) {
        const resultFlag = await SeaExportJob.isExistMBLNotCurrentCompany(job.opOffice, job.mbl, job.opDepartment)
        if (count > 0 && resultFlag) {
          return await this.checkMBLHandler(true)
        }
        if (resultFlag) {
          return await this.checkMBLNotCurrentCompanyHandler(true)
        }
      }
      return await this.checkMBLResultHandler(count > 0)
    } else {
      return true
    }
  }

  async checkMBLHandler(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.MblNoRepeatedNotCurrentCompanyContinueAll'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }

  async checkMBLNotCurrentCompanyHandler(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.MblNoRepeatedNotCurrentCompanyContinue'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
  async checkMBLResultHandler(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.MblNoRepeatedContinue'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }

  async checkCustomerRefNo() {
    const job = this.paramsOfTab
    const count = await SeaExportJob.isExistCustomerRefNo(this.context.office.officeId, 'SE', job.customerRefNo, job.uuid)
    if (count > 0) {
      return await this.$confirm(this.view.$t('Message.CustomerRefNoRepeatedContinue'), this.view.$t('FileHistory.Tips'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }

  /**
   * 检查HBL是否可用
   */
  async checkHBLExistHandler() {
    const job = this.paramsOfTab
    const hbl = await new SeaExportJob(job).getMainHbl()
    // for (const cd of job.seaCargoDoc) {
    //   if (cd.docType === 'HBL') {
    //     const s = job.containerDesc
    //     if (s && !cd.container) {
    //       cd.container = s.toLocaleUpperCase()
    //     }
    //   }
    // }
    if (job.editCftMode && (hbl.shipperId === 0 || hbl.consigneeId === 0 || hbl.notifyId === 0)) {
      throw ErrorTip(this.view.$t('SeaExport.ConsigneeRequired'))
    }
    if (hbl && job.signHBL && !job.mblOnly && !job.masterFlag && Number(this.config.get('isAllowSEHBLNoRepeat')) === 1) {
      // HBL的Doc存在, 且勾选了HB/L,没勾选直单,且不是主票的情况下,且开启配置的情况下 才检查
      if (job.uuid && hbl.hblNbr2 && hbl.hblNbr2.trim()) {
        const count = await SeaExportJob.isExistHBL(this.context.office.officeId, 'SE', hbl.hblNbr2, job.uuid, job.etd)
        return await this.checkHBLNoResultHandler(count > 0)
      } else {
        return true
      }
    } else {
      return true
    }
  }

  async checkHBLNoResultHandler(isExist) {
    if (isExist) {
      return await this.$confirm(this.view.$t('Message.HblNoRepeatedContinue'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
  // 检查输入的soNo是否重复
  async checkSoNoDuplicated() {
    const job = this.paramsOfTab
    let isRepect = false
    if (job.soNo) {
      const soNoList = job.soNo.split('\n')
      // 判断重复
      const hash = {}
      for (const i in soNoList) {
        if (hash[soNoList[i]]) {
          isRepect = true
          break
        }
        hash[soNoList[i]] = true
      }
    }
    if (isRepect) {
      return await this.checkSoNoDuplicatedHandler()
    }
    return true
  }
  async checkSoNoDuplicatedHandler() {
    return await this.$confirm(this.view.$t('Message.SoNoRepeatedContinue'), this.view.$t('FileHistory.Tips'), {
      confirmButtonText: this.view.$t('constant.yes'),
      cancelButtonText: this.view.$t('constant.no'),
      closeOnClickModal: false,
      type: 'info'
    }).then(() => true).catch(() => false)
  }

  async checkSoNo(job, soNos) {
    const count = await SeaExportJob.isExistSoNo(job.opOffice, 'SE', soNos, job.uuid)
    if (count > 0) {
      return await this.$confirm(this.view.$t('Message.SoNoRepeatedContinue'), this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    }
    return true
  }
  async checkAmsContainersHandler() {
    const obj = await this.checkAmsContainers()
    if (obj.canSave === 0) {
      return false
    } else if (obj.canSave === 2 && obj.returnStr) {
      return await this.$confirm(obj.returnStr, this.view.$t('Message.Prompt'), {
        confirmButtonText: this.view.$t('constant.yes'),
        cancelButtonText: this.view.$t('constant.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => true).catch(() => false)
    } else {
      return true
    }
  }
  async checkAmsContainers() {
    const job = this.paramsOfTab
    const obj = {}
    obj.canSave = 1
    if (job.masterFlag || !job.uuid) {
      return obj
    }
    const containers = job.containerUsages
    if (!containers || containers.length === 0) {
      return obj
    }
    const containersClone = deepCopy(containers)

    const cargoDocs = job.seaCargoDoc
    if (!cargoDocs || cargoDocs.length === 0) {
      return obj
    }

    // 找出该业务下AMS所有的EDIContainer
    const ediContainers = []
    for (const seaCargoDoc of cargoDocs) {
      if (CargoDocConsts.AMS === seaCargoDoc.docType) {
        await new SeaCargoDoc(seaCargoDoc).getEdiContainer()
        if (seaCargoDoc.ediContainer && seaCargoDoc.ediContainer.length > 0) {
          ediContainers.push(...seaCargoDoc.ediContainer)
        }
      }
    }
    if (ediContainers.length === 0) {
      return obj
    }
    const ediContainersClone = deepCopy(ediContainers)

    // 存箱号,不会重复
    const containerNos = []

    // 根据箱号汇总 AMS上的EDIContainer
    const ediContainerObj = {}
    for (const ediContainer of ediContainersClone) {
      const ediContainerStr = ediContainer.eqSize + ediContainer.eqType + ediContainer.containerNo + ediContainer.sealNo
      if (!ediContainerObj.ediContainerStr) {
        ediContainerObj[ediContainerStr] = ediContainer
        containerNos.push(ediContainerStr)
      } else {
        const oldEdiContainer = ediContainerObj[ediContainerStr]
        if (oldEdiContainer) {
          oldEdiContainer.quantity += ediContainer.quantity
          oldEdiContainer.weight += ediContainer.weight
          oldEdiContainer.cubage += ediContainer.cubage
          ediContainerObj[ediContainerStr] = oldEdiContainer
        }
      }
    }

    // 根据箱号汇总 job上的装箱信息
    const containerUsageObj = {}
    for (const containerUsage of containersClone) {
      const containerUsageStr = containerUsage.eqSize + containerUsage.eqType + containerUsage.containerNo + containerUsage.sealNo
      if (!containerUsageObj[containerUsageStr]) {
        containerUsageObj[containerUsageStr] = containerUsage
      } else {
        const oldContainerUsage = containerUsageObj[containerUsageStr]
        if (oldContainerUsage) {
          oldContainerUsage.quantity += containerUsage.quantity
          oldContainerUsage.weight += containerUsage.weight
          oldContainerUsage.cubage += containerUsage.cubage
          containerUsageObj[containerUsageStr] = oldContainerUsage
        }
      }
    }

    const returnMessage = this.view.$t('Message.AMS_ReturnMessage')
    const returnMessageCanSave = this.view.$t('Message.AMS_ReturnMessageCanSave')
    let containerMessage = ''
    // 将ams装箱信息和job上的装箱信息作比较
    for (const containerInfo of containerNos) {
      const ediContainerNow = ediContainerObj[containerInfo]
      if (!ediContainerNow) {
        continue
      }

      const containerUsageNow = containerUsageObj[containerInfo]
      if (!containerUsageNow || !containerUsageNow.container) {
        continue
      }

      let conMessage = ''
      if (ediContainerNow.quantity > containerUsageNow.quantity) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Quantity'), [NumberUtils.roundHalfUp3(ediContainerNow.quantity, 0), '>', NumberUtils.roundHalfUp3(containerUsageNow.quantity, 0)])
      }
      if (ediContainerNow.weight > containerUsageNow.weight) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Weight'), [NumberUtils.roundHalfUp3(ediContainerNow.weight, 3), '>', NumberUtils.roundHalfUp3(containerUsageNow.weight, 3)])
      }
      if (ediContainerNow.cubage > containerUsageNow.cubage) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Cubage'), [NumberUtils.roundHalfUp3(ediContainerNow.cubage, 3), '>', NumberUtils.roundHalfUp3(containerUsageNow.cubage, 3)])
      }
      if (ediContainerNow.quantity < containerUsageNow.quantity) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Quantity'), [NumberUtils.roundHalfUp3(ediContainerNow.quantity, 0), '<', NumberUtils.roundHalfUp3(containerUsageNow.quantity, 0)])
      }
      if (ediContainerNow.weight < containerUsageNow.weight) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Weight'), [NumberUtils.roundHalfUp3(ediContainerNow.weight, 3), '<', NumberUtils.roundHalfUp3(containerUsageNow.weight, 3)])
      }
      if (ediContainerNow.cubage < containerUsageNow.cubage) {
        conMessage += this.getFormatText(this.view.$t('Message.AMS_Cubage'), [NumberUtils.roundHalfUp3(ediContainerNow.cubage, 3), '<', NumberUtils.roundHalfUp3(containerUsageNow.cubage, 3)])
      }
      if (conMessage) {
        containerMessage += (this.getFormatText(this.view.$t('Message.AMS_ContainerNo'), [containerUsageNow.container.containerNo]) + conMessage)
      }
    }
    // 不能保存
    const isCanSave = containerMessage.indexOf('>') === -1
    if (!isCanSave) {
      obj.canSave = 0
      this.$message.warning(returnMessage + containerMessage)
      return obj
    }
    // 可以保存
    if (isCanSave && containerMessage.indexOf('<') !== -1) {
      obj.canSave = 2
      obj.returnStr = returnMessageCanSave + containerMessage
    }
    return obj
  }
  getFormatText(source, parameters) {
    if (parameters instanceof Array) {
      for (let i = 0; i < parameters.length; ++i) {
        source = source.replace('{' + i + '}', parameters[i])
      }
    }
    return source
  }
  async checkMBLNoRepeat(bodyJob) {
    const job = bodyJob
    // 委托拼箱、散杂货、特种箱 方案未提到要处理，无需验证
    if (!job.containerLoadType || job.containerLoadType === 'BB' || job.containerLoadType === 'BULK' || job.containerLoadType === 'SPA') {
      return true
    }
    const result = await SeaExportJob.checkMBLNoRepeat(job.mbl.trim(), job.uuid, job.masterFlag, job.lclMasterUuid, job.containerLoadType)
    if (result && result.count && result.jobNo) {
      this.view.$message.warning(this.view.$t('Message.MblNoRepeatedNotSave', [result.jobNo]))
      return false
    }
    return true
  }
}
